/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, arrayOf, bool, number,
    string, func, objectOf, shape,
} from 'prop-types';
import { connect } from 'react-redux';
import * as Joi from 'joi-browser';

import { withStyles } from '@material-ui/core/styles';

import { FormHelperText, Typography } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import Form from '../../../common/Form';
import { form as formStyle } from '../../../style/form';
import ErrorInline from '../../../common/ErrorMessages/ErrorInline';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import Apo from '../../../assets/svg/Apo';
import Business from '../../../assets/svg/Business';
import School from '../../../assets/svg/School';
import Church from '../../../assets/svg/Church';
import FuneralHome from '../../../assets/svg/FuneralHome';
import PoBox from '../../../assets/svg/PoBox';
import Hospital from '../../../assets/svg/Hospital';
import Residence from '../../../assets/svg/HomeSolid';
import { getSSRDeviceType } from '../../../../../../state/ducks/App/App-Selectors';
import ErrorLanguages from '../../../common/ErrorMessages/ErrorLanguages';

const styles = ({ typography, palette }) => formStyle(typography, palette);

class DesktopSelectAddressDropdown extends Form {
    state = {
        data: { addressbook: '0' }, errors: {}, inlineError: '', addressBooks: [], filterAddressBook: [], selectAdressBook: '',
    };

    schema = {
        addressbook: Joi.string()
            .alphanum()
            .required()
            .label('Address Book'),
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const { recipients, fetchAddressBook } = this.props;
        fetchAddressBook(recipients);
    };

    doSubmit = (submitData) => {
        const { data } = this.state;
        // console.log('doSumbit', data, eventInterface);
        // if (!data.addressbook === '0') return;
        if (data.addressbook === '0') {
            const inlineError = 'Error adding recipient to the gift list.';
            this.setState({ inlineError });
            return;
        }
        /* istanbul ignore next */
        if (typeof submitData === 'undefined') return;

        const {
            addressBooks,
            giftListRecipients,
            occasionId,
            // eslint-disable-next-line no-unused-vars
            handleSubmitAddNewRecipient,
        } = submitData;

        const index = addressBooks.findIndex((item) => item.id.toString() === data.addressbook);
        if (index < 0) {
            const inlineError = 'There is something wrong with selected address.';
            this.setState({ inlineError });
            return;
        }
        const {
            FirstName, LastName, EmployerName, NickName = '',
            RelationShip = '0', PhoneNumber = '', Addresses = [],
        } = addressBooks[index];
        const {
            AddressType, AddressLineOne, AddressLineTwo,
            City, StateProvince, PostalCode, Country,
        } = Addresses[0];

        // Check if this recipient was already added to the gift list
        const recipientFound = giftListRecipients[occasionId].filter((item) => item?.firstname?.toUpperCase() === FirstName?.toUpperCase()
                && item?.lastname?.toUpperCase() === LastName?.toUpperCase()
                && item?.address?.street?.toUpperCase() === AddressLineOne?.toUpperCase()
                && item?.address?.apt?.toUpperCase() === AddressLineTwo?.toUpperCase()
                && item?.address?.city?.toUpperCase() === City?.toUpperCase()
                && item?.address?.country.id?.toUpperCase() === Country?.toUpperCase()
                && item?.address?.location.name?.toUpperCase() === AddressType?.toUpperCase()
                && item?.address?.state.id?.toUpperCase() === StateProvince?.toUpperCase()
                && item?.address?.zipcode.replace(/-\d{4}$/, '') === PostalCode.replace(/-\d{4}$/, ''));
        if (recipientFound && recipientFound.length) {
            const errors = {
                addressbook: `${FirstName} ${LastName} has been added to the gift list.`,
            };
            this.setState({ errors });
            return;
        }
        const recipientData = {
            addressEntry: {
                FirstName,
                LastName,
                EmployerName,
                NickName,
                RelationShip,
                PhoneNumber,
            },
            address: {
                AddressType,
                AddressLineOne,
                AddressLineTwo,
                City,
                StateProvince,
                PostalCode,
                Country,
                IsBillingAddress: false,
            },
        };
        handleSubmitAddNewRecipient(
            recipientData,
            '',
            '',
            'GiftListRecipientForm',
            occasionId,
            '',
            1,
            {},
        );
    };

    doChange = () => {
        this.setState({ inlineError: '' });
    };

    loadIcon = (value) => {
        switch (value) {
            case 'Business':
                return <Business className="svgIcon" />;
            case 'School':
                return <School className="svgIcon" />;
            case 'Church':
                return <Church className="svgIcon" />;
            case 'Funeral home':
                return <FuneralHome className="svgIcon" />;
            case 'P.O.Box':
                return <PoBox className="svgIcon" />;
            case 'Hospital':
                return <Hospital className="svgIcon" />;
            case 'Residence':
                return <Residence className="svgIcon" />;
            case 'Apartment':
                return <Residence className="svgIcon" />;
            default:
                return <Apo className="svgIcon" />;
        }
    }

    componentWillReceiveProps(nextProps) {
        const { recipients } = nextProps;
        const addressBooks = [
            {
                id: 0,
                name: 'Select From Contacts',
                FirstName: '',
                LastName: '',
                NickName: '',
                EmployerName: '',
                Addresses: [],
                RelationShip: 0,
                PhoneNumber: '',
            },
        ];

        recipients.forEach((r) => {
            addressBooks.push({
                id: r.AddressBookEntryId,
                name: `${r.FirstName} ${r.LastName}`,
                FirstName: r.FirstName,
                LastName: r.LastName,
                NickName: r.NickName,
                EmployerName: r.EmployerName,
                Addresses: r.Addresses,
                RelationShip: r.RelationShip,
                PhoneNumber: r.PhoneNumber,
            });
        });
        this.setState({ addressBooks });
    }

    handleSearchChange=(e) => {
        const search = e.target.value;
        const { addressBooks } = this.state;
        const recipients = addressBooks.filter((r) => [
            r.FirstName,
            r.LastName,
            r.EmployerName,
            r.PhoneNumber,
            r.Addresses?.[0]?.AddressLineOne,
            r.Addresses?.[0]?.AddressLineTwo,
            r.Addresses?.[0]?.City,
        ]
            .join(' ')
            .match(new RegExp(search, 'ig')));
        this.setState({ filterAddressBook: recipients });
    }

    addressBookLayout = () => {
        const {
            onChange,
            classes,
            ssrDeviceType,
        } = this.props;

        const {
            addressBooks, filterAddressBook, selectAdressBook, errors,
        } = this.state;
        const errorMessage = ErrorLanguages(errors['addressbook']);
        const isError = typeof errorMessage !== 'undefined';
        const SelectedAddressBook = filterAddressBook.length ? filterAddressBook : addressBooks;
        return (
            <>

                {SelectedAddressBook.map((option) => {
                    const Addresses = option?.Addresses?.length ? option?.Addresses?.[0] : '';
                    return (
                        Addresses
                            ? (
                                <div
                                    className={selectAdressBook === option.id ? `${classes.selectedAddress} ${classes.addressContainer} ${isError ? classes.errorContainer : ''}` : classes.addressContainer}
                                    role="presentation"
                                    onClick={(event) => {
                                        this.handleChange(event, '', onChange);
                                        this.setState({ selectAdressBook: option.id });
                                    }}
                                    name="addressbook"
                                    data-value={option.id}
                                >
                                    <Typography className={classes.profileName}>{option?.FirstName} {option.LastName}</Typography>
                                    <div>
                                        {Addresses?.AddressLineOne && Addresses?.AddressLineOne}
                                        {`${Addresses?.City}, ${Addresses?.PostalCode}`}
                                    </div>
                                    {ssrDeviceType !== 'mobile' && this.loadIcon(Addresses?.AddressType)}
                                </div>
                            )
                            : ''
                    );
                })}
            </>
        );
    }

    render() {
        const {
            classes,
            isReadyState,
            occasionId,
            recipients,
            giftListRecipients,
            onChange,
            handleSubmitAddNewRecipient,
            activeTab,
            giftListV2,
            handleCloseModal,
        } = this.props;
        const {
            inlineError, data, addressBooks, errors,
        } = this.state;
        const errorMessage = ErrorLanguages(errors['addressbook']);
        const isError = typeof errorMessage !== 'undefined';
        /* istanbul ignore next */
        if (!recipients) return null;

        const submitData = {
            addressBooks,
            occasionId,
            giftListRecipients,
            handleSubmitAddNewRecipient,
        };

        return (
            <>
                {giftListV2 && activeTab === 'tab2'
               && (
                   <div className={classes.inputContianer}>
                       <input onChange={(e) => this.handleSearchChange(e)} />
                       <Search />
                       {isError && <FormHelperText className={classes.error}>{errorMessage}</FormHelperText>}
                   </div>
               )}
                <form
                    onSubmit={(event) => this.handleSubmit(event, submitData)}
                    className={giftListV2 && activeTab === 'tab2' ? `${classes.selectedForm} ${classes.form}` : classes.form}
                >
                    <ErrorInline
                        error={inlineError}
                        customClass="margin-top"
                        isReadyState={isReadyState}
                    />

                    {giftListV2
                        ? activeTab === 'tab2' && this.addressBookLayout()
                        : this.renderSelect({
                            name: 'addressbook',
                            label: '',
                            options: addressBooks,
                            onChangeHandler: onChange,
                        })}
                    {giftListV2 && activeTab === 'tab2'
                && (
                    <div
                        className={classes.adressButtonContainer}
                    >
                        {this.renderButton({
                            label: 'Cancel',
                            className: 'cancelButton',
                            onClick: handleCloseModal,
                            type: 'button',
                            isValidated: false,
                        })}
                        {this.renderButton({
                            label: 'Add Recipient',
                            className: 'submitButton',
                            onClick: null,
                            type: 'submit',
                        })}
                    </div>
                )}

                    <div
                        className={
                            data.addressbook !== '0' && !giftListV2
                                ? 'margin-top-2x'
                                : 'display-none'
                        }
                    >
                        {this.renderButton({
                            label: 'Add Recipient',
                            className: 'no-margin',
                            onClick: null,
                            type: 'submit',
                        })}
                    </div>
                </form>

            </>
        );
    }
}

DesktopSelectAddressDropdown.defaultProps = {
    recipients: [],
    addressBooks: [],
    onChange: () => {},
    handleSubmitAddNewRecipient: () => {},
    fetchAddressBook: () => {},
};

DesktopSelectAddressDropdown.propTypes = {
    classes: object.isRequired,
    isReadyState: bool.isRequired,
    occasionId: string.isRequired,
    giftListRecipients: objectOf(
        arrayOf(
            shape({
                AddressBookEntryId: string,
                addToCart: string,
                address: shape({
                    addressId: string,
                    apt: string,
                    city: string,
                    company: string,
                    country: shape({
                        id: string,
                        name: string,
                    }),
                    location: shape({
                        id: number,
                        name: string,
                    }),
                    state: shape({
                        id: string,
                        name: string,
                    }),
                    street: string,
                    zipcode: string,
                }),
                addressId: string,
                cartDetail: object,
                error: object,
                firstname: string,
                giftArrived: string,
                id: string,
                isNewRecipient: bool,
                lastname: string,
                occasionId: string,
                orderItemId: string,
                products: arrayOf(
                    shape({
                        content: string,
                        crossedPrice: number,
                        discountPrice: number,
                        id: string,
                        image: string,
                        name: string,
                        parentCatalogEntryId: string,
                        partNumber: string,
                        price: number,
                        seoproductDisplayURL: string,
                        sku: string,
                        status: string,
                    }),
                ),
            }),
        ),
    ),
    recipients: arrayOf(
        shape({
            AddressBookEntryId: string,
            Addresses: arrayOf(
                shape({
                    AddressBookEntryId: string,
                    AddressId: number,
                    AddressLineOne: string,
                    AddressLineTwo: string,
                    AddressType: string,
                    City: string,
                    ContactId: number,
                    Country: string,
                    IsBillingAddress: bool,
                    IsPartialMatch: bool,
                    IsUnknownAddress: bool,
                    PostalCode: string,
                    StateProvince: string,
                }),
            ),
            ContactId: number,
            EmployerName: string,
            FirstName: string,
            LastName: string,
            LastUpdateDate: string,
            NickName: string,
            NumberOfAddresses: number,
            RelationShip: string,
        }),
    ),
    onChange: func,
    handleSubmitAddNewRecipient: func,
    fetchAddressBook: func,
    ssrDeviceType: string.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state.account ? state.account : state;
    return {
        isReadyState: newState.isReadyState,
        occasionId: newState.giftList.occasionId,
        recipients: newState.recipients,
        giftListRecipients: newState.giftList.recipients,
        ssrDeviceType: getSSRDeviceType(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleSubmitAddNewRecipient: (data, AddressId, AddressBookEntryId, templateName, occasionId, orderItemId, currentPage, recipient) => dispatch(EventDispatcher.handleSubmitAddNewRecipient(
        data,
        AddressId,
        AddressBookEntryId,
        templateName,
        occasionId,
        orderItemId,
        currentPage,
        recipient,
    )),
    fetchAddressBook: (recipients) => dispatch(EventDispatcher.fetchAddressBook(recipients)),
    handleCloseModal: () => dispatch(EventDispatcher.handleCloseModal()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(DesktopSelectAddressDropdown));
